import React from 'react'
import { useNavigate } from 'react-router-dom'
import { css } from '@emotion/react'
import { useTranslation } from 'react-i18next'
import { useAppDispatch } from '@/app/hooks'
import { skipSurvey } from '@/features/survey/survey-skip-slice'
import { SurveySkipRequest, SurveySource } from '@/features/survey/survey-types'
import { errorHandler } from '@/libs/errors'
import { CUSTOM_BLOCK } from '@/components/template/custom-design-style'
import { RightIcon } from '@/components/atoms/icon'
import { useCheckout } from '@/hooks/use-checkout'

interface SkipSurveyProps {
  reservationIds: string[]
  hotelId: string
  source?: SurveySource
}

/**
 * アンケートスキップコンポーネント
 * アンケートをスキップしてチェックアウト完了ページへ遷移
 */
export const SurveySkip: React.FC<SkipSurveyProps> = ({ reservationIds, hotelId, source = 'checkout' }) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  // チェックアウト処理用のフック
  const { handleCheckout } = useCheckout({
    hotelId,
  })

  const handleSkip = async () => {
    const requestBody: SurveySkipRequest = {
      hotelId,
      reservationIds,
      responseSource: source,
    }

    try {
      // 先にチェックアウト処理を実行
      await handleCheckout()
      // チェックアウト完了後、アンケートスキップ処理を実行
      await dispatch(skipSurvey(requestBody)).unwrap()
      // スキップ成功後、チェックアウト完了ページへ遷移
      navigate('/checkout/thanks')
    } catch (error) {
      errorHandler({ error })
    }
  }

  return (
    <div onClick={handleSkip} className={CUSTOM_BLOCK} css={containerStyle}>
      <span css={skipTextStyle}>{t('Skip survey and checkout')}</span>
      <RightIcon />
    </div>
  )
}

const containerStyle = css({
  padding: '0.5rem 2rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '8px',
  svg: {
    flexShrink: 0,
  },
})

const skipTextStyle = css({
  fontSize: '14px',
  color: '#B0A497',
  fontWeight: 400,
  lineHeight: 1.5,
  flex: 1,
})
